(() => {
  if (window.MayLondonI18n) return;
  let config = {};
  try { config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}'); } catch (_) {}
  const locale = config.locale === 'en' || !config.locale ? 'en-GB' : config.locale;
  const root = '/' + String(config.root || window.Shopify?.routes?.root || '/').replace(/^\/+|\/+$/g, '');
  const prefix = root === '/' ? '' : root;
  const strings = config.strings || {};
  const number = value => new Intl.NumberFormat(locale).format(Number(value || 0));
  const percent = value => new Intl.NumberFormat(locale, {style:'percent',maximumFractionDigits:1}).format(Number(value || 0) / 100);
  const money = cents => new Intl.NumberFormat(locale, {style:'currency',currency:config.currency || 'GBP'}).format(Number(cents || 0) / 100);
  const date = (value, options = {dateStyle:'medium'}) => new Intl.DateTimeFormat(locale, options).format(new Date(value));
  function t(key, variables = {}, count) {
    key = String(key).replace(/^js\./, '');
    const quantity = count ?? variables.count;
    let template;
    if (quantity !== undefined) template = strings[key + '_' + new Intl.PluralRules(locale).select(Number(quantity))] ?? strings[key + '_other'];
    template ??= strings[key];
    template ??= key;
    const values = {...variables};
    if (quantity !== undefined) values.count = number(quantity);
    return String(template).replace(/__ML_(\w+)__/g, (_, name) => values[name] ?? '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => values[name] ?? '');
  }
  function unlocalize(value) {
    const pathname = String(value || '/');
    if (prefix && (pathname === prefix || pathname.startsWith(prefix + '/'))) return pathname.slice(prefix.length) || '/';
    return pathname.replace(/^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*(?=\/(?:products|collections|search|cart|checkout|account|pages|policies|recommendations|discount|apps|contact)(?:\/|\.|\?|$))/i, '');
  }
  function route(value) {
    if (/^(?:https?:)?\/\//i.test(String(value))) {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return url.href;
      value = url.pathname + url.search + url.hash;
    }
    if (/^(?:mailto:|tel:|#)/i.test(String(value))) return value;
    const path = '/' + String(value || '').replace(/^\/+/, '');
    if (prefix && (path === prefix || path.startsWith(prefix + '/') || path.startsWith(prefix + '?'))) return path;
    return prefix + unlocalize(path);
  }
  const message = (error, key) => error?.message && !['TypeError','SyntaxError','AbortError'].includes(error.name) ? error.message : t(key);
  window.MayLondonI18n = {t, money, number, percent, date, route, unlocalize, message, locale};
})();
